import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgPrincipleModule } from '@principle-theorem/ng-principle';
import {
  BreadcrumbsComponent,
  type IBreadcrumb,
} from '@principle-theorem/ng-shared';
import { Partner } from '@principle-theorem/principle-core';
import {
  type IPartner,
  type IUser,
} from '@principle-theorem/principle-core/interfaces';
import {
  filterUndefined,
  findProp,
  type CollectionReference,
  type WithRef,
} from '@principle-theorem/shared';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'pr-partner-user-list',
  templateUrl: './partner-user-list.component.html',
  styleUrls: ['./partner-user-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, BreadcrumbsComponent, NgPrincipleModule],
})
export class PartnerUserListComponent {
  userCollection$: Observable<CollectionReference<IUser>>;
  breadcrumbs$: Observable<IBreadcrumb[]>;

  constructor(private _route: ActivatedRoute) {
    const partner$ = this._route.data.pipe(
      findProp<WithRef<IPartner>>('partner'),
      filterUndefined()
    );

    this.userCollection$ = partner$.pipe(
      map((partner) => Partner.userCol(partner))
    );

    this.breadcrumbs$ = partner$.pipe(
      map((partner) => [
        { label: 'Partners', path: '../../' },
        { label: partner.name, path: '../' },
        { label: 'Users' },
      ])
    );
  }
}
